<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'common.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <div [innerHTML]="'news-articles.search.results-count' | translate: { count: searchResult.TotalCount } | ucfirst"></div>
  </ng-template>
  <button pButton type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'common.clear-search' | translate | uppercase }}</span>
  </button>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    [lazy]="true"
    (onLazyLoad)="lazyLoad($event)"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ShortDescr">
          {{ 'news-articles.search.title' | translate | ucfirst }}
          <p-sortIcon field="ShortDescr"></p-sortIcon>
        </th>
        <th pSortableColumn="ArticleType">
          {{ 'news-articles.search.article-type' | translate | ucfirst }}
          <p-sortIcon field="ArticleType"></p-sortIcon>
        </th>
        <th pSortableColumn="StartDate" class="t-ac" [style]="{ width: '120px' }">
          {{ 'news-articles.search.article-date' | translate | ucfirst }}
          <p-sortIcon field="StartDate"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-newsArticle>
      <tr>
        <td>
          {{ newsArticle.ShortDescr }}
        </td>
        <td>
          {{ newsArticle.ArticleType }}
        </td>
        <td class="t-ac">
          {{ newsArticle.ArticleDate | date: 'MM/dd/yyyy' }}
        </td>
        <td class="t-ac">
          <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForNewsArticle(newsArticle)">
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
</div>

<wl-news-article-edit-dialog #editDialog (saved)="search()"></wl-news-article-edit-dialog>

<p-confirmDialog
  #cd
  key="deleteArticleCD"
  header="{{ 'news-articles.delete.confirm-delete-header' | translate | titlecase }}"
  message="{{ 'news-articles.delete.article-delete-message' | translate }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
